import * as React from "react";
// App.jsx - Updated with route protection
import { Routes, Route } from "react-router-dom";
import LoginPage from "./pages/auth/LoginPage";
import SignupPage from "./pages/auth/SignupPage";
import LandingPage from "./pages/LandingPage";
import { Layout } from "./components/layout/Layout";
import ProductsPage from "./pages/products/ProductsPage";
import ProductDetailsPage from "./pages/products/ProductDetailsPage";
import CampaignsPage from "./pages/products/CampaignsPage";
import AdStatsPage from "./pages/products/AdStatsPage";
import NotFound from "./components/states/NotFound";
import { PublicRoute } from "./components/auth/PublicRoute";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import ConnexionsPage from "./pages/campaign launching/ConnexionsPage";
import AdAccountsPage from "./pages/campaign launching/AdAccountsPage";
import AdsLauncherPage from "./pages/campaign launching/AdsLauncherPage";
import AdsetLauncherPage from "./pages/campaign launching/AdsetLauncherPage";
import PagesPage from "./pages/MarketLab/PagesPage";
import MarketlabsProductsPage from "./pages/MarketLab/MarketlabsProductsPage";
import AdsPage from "./pages/MarketLab/AdsPage";
import MarketProductDetailsPage from "./pages/MarketLab/MarketProductDetailsPage";

function App() {
  return (
    <Routes>
      {/* Public routes (login/signup/landing) */}
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
      </Route>

      {/* Landing page (accessible to all) */}
      <Route path="/" element={<LandingPage />} />

      {/* Protected routes (require authentication) */}
      <Route element={<ProtectedRoute />}>
        <Route
          path="/product/:id"
          element={
            <Layout>
              <ProductDetailsPage />
            </Layout>
          }
        />
        <Route
          path="/product/:id/campaign/:campaignId"
          element={
            <Layout>
              <CampaignsPage />
            </Layout>
          }
        />
        <Route
          path="/product/:id/campaign/:campaignId/ad/:adId"
          element={
            <Layout>
              <AdStatsPage />
            </Layout>
          }
        />

        <Route
          path="/Product_All"
          element={
            <Layout>
              <ProductsPage />
            </Layout>
          }
        />

        {/* MarketLab Routes */}
        <Route
          path="/marketlab/pages"
          element={
            <Layout>
              <PagesPage />
            </Layout>
          }
        />
        <Route
          path="/MarketProduct_All"
          element={
            <Layout>
              <MarketlabsProductsPage />
            </Layout>
          }
        />
        <Route
          path="/market-product/:id"
          element={
            <Layout>
              <MarketProductDetailsPage />
            </Layout>
          }
        />
        <Route
          path="/marketlab/ads"
          element={
            <Layout>
              <AdsPage />
            </Layout>
          }
        />

        {/* Campaign Launching */}
        <Route
          path="/All_Connexions"
          element={
            <Layout>
              <ConnexionsPage />
            </Layout>
          }
        />
        <Route
          path="/campaign/ad-accounts"
          element={
            <Layout>
              <AdAccountsPage />
            </Layout>
          }
        />
        <Route
          path="/campaign/ads-launcher"
          element={
            <Layout>
              <AdsLauncherPage />
            </Layout>
          }
        />
        <Route
          path="/AdSet_All"
          element={
            <Layout>
              <AdsetLauncherPage />
            </Layout>
          }
        />

        {/* End - Campaign Launching */}

        <Route
          path="/dashboard/real-time"
          element={
            <Layout>
              <div>Real Time</div>
            </Layout>
          }
        />
      </Route>

      {/* 404 Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
